export const GET_MUNICIPALITY_LIST = 'MUNICIPALITY/get_municipality_list';
export const GET_MUNICIPALITY_SELECTED =
  'MUNICIPALITY/SHOW_MUNICIPALITY';
export const UPDATE_MUNICIPALITY = 'MUNICIPALITY/update_municipality';

export const GET_PROVINCE = 'MUNICIPALITY/get_province';

export const GET_REGION = 'MUNICIPALITY/get_region';

export const FORM_DATA = {
  name: '',
  description: '',
};

export const FORM_DATA_NATURE_BUSINESS = {
  code: '',
  name: '',
  description: '',
};
